import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { INTEGRATIONS_MAX_FORM_LIMIT } from '../lib/constants';

export const useFormSchemaCreate = () => {
  const { t } = useTranslation('translation');

  const requiredMessage = t('common.formErrors.required');
  const maxTitleMessage = t('common.formErrors.stringMaxLen', {
    max: INTEGRATIONS_MAX_FORM_LIMIT.title,
  });
  const maxCallbackUrlMessage = t('common.formErrors.stringMaxLen', {
    max: INTEGRATIONS_MAX_FORM_LIMIT.callbackUrl,
  });

  const baseFields = z
    .object({
      title: z
        .string()
        .trim()
        .min(1, requiredMessage)
        .max(INTEGRATIONS_MAX_FORM_LIMIT.title, maxTitleMessage),
      callbackUrl: z
        .string()
        .trim()
        .min(1, requiredMessage)
        .max(INTEGRATIONS_MAX_FORM_LIMIT.callbackUrl, maxCallbackUrlMessage),
      method: z.enum(['GET', 'POST']),
    })
    .passthrough();

  return {
    baseFields,
  };
};
